<template>
  <BaseCard class="border-0">
    <BaseCardBody>
      <div class="flex -mx-4">
        <div class="px-4 w-64">
          <template v-if="cover">
            <img
              v-if="cover"
              :srcset="cover.srcsets || ''"
              @load.once="onImageLoad"
              sizes="1px"
              :src="cover.url"
              class="rounded-sm object-cover w-full h-32"
            />
          </template>
          <template v-else>
            <div class="rounded-sm bg-gray-200 object-cover w-full h-32" />
          </template>
        </div>
        <div class="flex flex-col flex-1 px-4">
          <h6 class="text-base mb-2">
            {{ productService.name }}
          </h6>
          <div>
            <BaseBadge v-if="productService.optional" key="optional" purple class="uppercase">
              optional
            </BaseBadge>
            <BaseBadge v-else key="basic" silver class="uppercase"> basic </BaseBadge>
          </div>
          <div class="mt-auto -ml-4 flex">
            <BaseButton ghost @click="$emit('product-service-upgrade-create', productService.uuid)">
              Add Upgrade
            </BaseButton>
            <BaseButton
              primary
              class="ml-auto"
              @click="$emit('product-service-edit', productService.uuid)"
            >
              Edit
            </BaseButton>
            <BaseButton
              ghost
              class="ml-2"
              @click="$emit('product-service-delete', productService.uuid)"
            >
              Delete
            </BaseButton>
          </div>
        </div>
      </div>
    </BaseCardBody>
    <BaseCardBody v-if="upgrades.length" class="bg-gray-200 border-t">
      <span class="uppercase text-muted text-xs font-medium block ml-4">upgrades</span>
      <ul class="mt-4">
        <li
          v-for="productServiceUpgrade in upgrades"
          :key="productServiceUpgrade.uuid"
          class="py-1"
        >
          <UpgradeCard
            :product-service-upgrade="productServiceUpgrade"
            @product-service-upgrade-edit="editUpgrade(productServiceUpgrade.uuid)"
            @product-service-upgrade-delete="deleteUpgrade(productServiceUpgrade.uuid)"
          />
        </li>
      </ul>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import { mapState } from 'vuex';
import mediableMixin from '@/mixins/mediableMixin';
import UpgradeCard from './UpgradeCard.vue';

const defaultProduct = {
  name: 'Product Name',
  price: 0,
  optional: false,
  requirements: null,
};

export default {
  name: 'GridCard',
  mixins: [mediableMixin],
  components: {
    UpgradeCard,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('entities', ['products', 'productServices']),
    productService() {
      return { ...defaultProduct, ...this.entity };
    },
    service() {
      return this.products.byId[this.entity.serviceUuid] || null;
    },
    cover() {
      const { media = [] } = this.service || {};
      return media.find((item) => item.collection === 'images') || null;
    },
    upgrades() {
      const { upgrades = [] } = this.entity || {};

      return upgrades.map((upgradeId) => this.productServices.byId[upgradeId]);
    },
  },
  methods: {
    editUpgrade(productServiceUpgradeUuid) {
      this.$emit('product-service-upgrade-edit', productServiceUpgradeUuid);
    },
    deleteUpgrade(productServiceUpgradeUuid) {
      this.$emit('product-service-upgrade-delete', productServiceUpgradeUuid);
    },
  },
};
</script>
